import { useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getManHourProjectReport = async ({
  fromDate,
  toDate,
  companyCode,
  locationCode = "",
  employeeCode = 0,
  projectCode = "",
  isAllCompanies = false,
  selectedCompanyCode = "",
  userId = 0,
}) => {
  try {
    if (!companyCode || !fromDate || !toDate) {
      throw new Error("Company code, From date, and To date are required");
    }

    let queryString = `CompanyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&FromDate=${fromDate}&ToDate=${toDate}`;

    if (locationCode) {
      queryString += `&LocationCode=${locationCode}`;
    }

    if (employeeCode) {
      queryString += `&EmployeeCode=${employeeCode}`;
    }

    if (projectCode) {
      queryString += `&ProjectCode=${projectCode}`;
    }
    if (isAllCompanies && userId !== 0) {
      queryString += `&UserId=${userId}`;
    }

    const { data } = await http_payroll.get(
      `${
        isAllCompanies
          ? Api_EndPoints.AllCompanies_GetMonthlyManHourReport
          : Api_EndPoints.ManHourProjectReport
      }?${queryString}`,
    );
    return data;
  } catch (error) {
    console.error("Error fetching man hour project report:", error);
    throw error;
  }
};

const getProjectWiseTimeReport = async ({
  fromDate,
  toDate,
  companyCode,
  locationCode = "",
  employeeCode = 0,
  projectCode = "",
  isAllCompanies = false,
  selectedCompanyCode = "",
  userId = 0,
}) => {
  try {
    if (!companyCode || !fromDate || !toDate) {
      throw new Error("Company code, From date, and To date are required");
    }

    let queryString = `CompanyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&FromDate=${fromDate}&ToDate=${toDate}`;

    if (locationCode) {
      queryString += `&LocationCode=${locationCode}`;
    }

    if (employeeCode) {
      queryString += `&EmployeeCode=${employeeCode}`;
    }

    if (projectCode) {
      queryString += `&ProjectCode=${projectCode}`;
    }

    if (isAllCompanies && userId !== 0) {
      queryString += `&UserId=${userId}`;

      const { data } = await http_payroll.get(
        `${Api_EndPoints.AllCompanies_GetProjectWiseReport}?${queryString}`,
      );
      return data;
    }

    const { data } = await http_payroll.get(
      `${Api_EndPoints.ProjectWiseReport}?${queryString}`,
    );
    return data;
  } catch (error) {
    console.error("Error fetching project-wise time report:", error);
    throw error;
  }
};

const getProjectWiseReport = async ({
  fromDate,
  toDate,
  companyCode,
  locationCode = "",
  employeeCode = 0,
  projectCode = "",
}) => {
  try {
    if (!companyCode || !fromDate || !toDate) {
      throw new Error("Company code, From date, and To date are required");
    }

    let queryString = `CompanyCode=${companyCode}&FromDate=${fromDate}&ToDate=${toDate}`;

    if (locationCode) {
      queryString += `&LocationCode=${locationCode}`;
    }

    if (employeeCode) {
      queryString += `&EmployeeCode=${employeeCode}`;
    }

    if (projectCode) {
      queryString += `&ProjectCode=${projectCode}`;
    }

    const { data } = await http_payroll.get(
      `${Api_EndPoints.GetEmpProjectReport}?${queryString}`,
    );
    return data;
  } catch (error) {
    console.error("Error fetching project-wise time report:", error);
    throw error;
  }
};

export const useGetManHourReportQuery = (input) => {
  return useQuery({
    queryKey: [
      input?.isAllCompanies
        ? Api_EndPoints.AllCompanies_GetMonthlyManHourReport
        : Api_EndPoints.ManHourProjectReport,
    ],
    queryFn: () => getManHourProjectReport(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetProjectWiseTimeReportQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.ProjectWiseReport],
    queryFn: () => getProjectWiseTimeReport(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetProjectWiseReportQuery = (input) => {
  const isAllCompanies = Boolean(input?.isAllCompanies);
  return useQuery({
    queryKey: [
      isAllCompanies
        ? Api_EndPoints.AllCompanies_GetProjectWiseReport
        : Api_EndPoints.GetEmpProjectReport,
    ],
    queryFn: () => getProjectWiseTimeReport(input),
    refetchOnWindowFocus: false,
  });
};

const getProjectCostingReport = async ({
  companyCode,
  fromDate,
  toDate,
  userCode,
  userId,
  employeeCode = 0,
  locationCode,
  isAllCompanies = false,
  selectedCompanyCode = "",
}) => {
  try {
    let queryString = `CompanyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&FromDate=${fromDate}&ToDate=${toDate}&UserCode=${userCode}&LocationCode=${locationCode}`;

    if(employeeCode) {
      queryString += `&EmployeeCode=${employeeCode}`
    }
    if (isAllCompanies && userId !== 0) {
      queryString += `&UserId=${userId}`;
    }

    const { data } = await http_payroll.get(
      `${isAllCompanies ? Api_EndPoints.AllCompanies_GetProjectCostingReport : Api_EndPoints.GetProjectCostingReport}?${queryString}`,
    );
    return data;
  } catch (error) {
    console.error("Error fetching project-wise time report:", error);
    throw error;
  }
};

export const useGetProjectCostingReportQuery = (input) => {
  return useQuery({
    queryKey: [
      input?.isAllCompanies
        ? Api_EndPoints.AllCompanies_GetProjectCostingReport
        : Api_EndPoints.GetProjectCostingReport,
    ],
    queryFn: () => getProjectCostingReport(input),
    refetchOnWindowFocus: false,
  });
};
